export default {
  collapse: 'Collapse Menu',
  expand: 'Expand Menu',
};
